import { createTheme } from "@mui/material/styles";

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#303030",
      paper: "#424242"
    },
    primary: {
      main: "#ffffff",
      subtitle: "#d3d3d3"
    },
    secondary: {
      main: "#d3d3d3"
    },
    action: {
      disabledBackground: "#d3d3d3",
      disabled: "#808080"
    },
    colors: {
      main: "#40403f",
      appBar: "#484848",
      highlight: "#1c1c1c",
      disabled: "#808080",
      gradeNumberBackground: "#40403f",
      buttonBackground: "#707070",
      buttonHover: "#909090",
      counterBackground: "#707070",
      warning: "#ffbf00",
      remove: "#f35f5f",
      discount: "#1788ce",
      mercadoPagoBackgroundColor: "#171E2E",
      qrCodeBackground: "#000000",
      goldmineGray: "#696969",
      goldmineRed: "#c55006",
      goldmineGreen: "#1aa626",
      goldmineBlue: "#2a9bd7",
      goldmineMint: "#2d51e0",
      highlightBorder: "#2a9bd7",
      highlightButton: "#2a2a2a",
      highlightSpine: "#ece81f",
      breadcrumb: "#d3d3d3",
      pricingNotification: "rgba(255,251,19,1)",
      criticalNotification: "rgba(255,19,19,1)",
      messageNotification: "rgba(19,165,255,1)",
      progressRunning: "rgb(10,71,204)",
      progressError: "rgb(185,14,14)",
      progressSuccess: "rgb(9,131,28)",
      border: "#626262",
      ownChat: "#2c376e",
      otherChat: "#1a1c1c",
      chatSubheader: "#444444",
      drawerBackgroundColor: "#333333",
      divider: "#303030",
      filterHeaderBackground: "#252525"
    }
  },
  typography: {
    fontFamily: `"Inter", sans-serif`,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 1000
  }
});

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: "#f5f6fa",
      paper: "#ffffff"
    },
    primary: {
      main: "#1a1a1a",
      subtitle: "#555555"
    },
    secondary: {
      main: "#6e6e6e"
    },
    action: {
      disabledBackground: "#e0e0e0",
      disabled: "#9e9e9e"
    },
    colors: {
      main: "#f5f6fa",
      appBar: "#ffffff",
      highlight: "#e9eef5",
      disabled: "#9e9e9e",
      gradeNumberBackground: "#eeeeee",
      buttonBackground: "#ffffff",
      buttonHover: "#e0e0e0",
      counterBackground: "#f0f0f0",
      warning: "#ff9800",
      remove: "#d32f2f",
      discount: "#4196ec",
      mercadoPagoBackgroundColor: "#e8f0ff",
      qrCodeBackground: "#ffffff",
      goldmineGray: "#afafaf",
      goldmineRed: "#f65a5a",
      goldmineGreen: "#2cde3c",
      goldmineBlue: "#7bcbff",
      goldmineMint: "#7a7ff3",
      highlightBorder: "#1976d2",
      highlightButton: "#e9eef5",
      highlightSpine: "#c6c200",
      breadcrumb: "#666666",
      pricingNotification: "rgb(200,198,40)",
      criticalNotification: "rgb(183,28,28)",
      messageNotification: "rgb(25,118,210)",
      progressRunning: "rgb(53,106,229)",
      progressError: "rgb(231,72,72)",
      progressSuccess: "rgb(38,187,61)",
      border: "#dddddd",
      ownChat: "#e8eaf6",
      otherChat: "#f5f6fa",
      chatSubheader: "#ffffff",
      drawerBackgroundColor: "#ffffff",
      divider: "#e0e0e0",
      filterHeaderBackground: "#f0f0f0"
    }
  },
  typography: {
    fontFamily: `"Inter", sans-serif`,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 1000
  }
});

export const blackTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#201f26",
      paper: "#2c2b34"
    },
    primary: {
      main: "#ffffff",
      subtitle: "#cccccc"
    },
    secondary: {
      main: "#939393"
    },
    action: {
      disabledBackground: "#b2b2b2",
      disabled: "#808080"
    },
    colors: {
      main: "#201f26",
      appBar: "#0f0e17",
      highlight: "#0f0e17",
      disabled: "#808080",
      gradeNumberBackground: "#2b2b2b",
      buttonBackground: "#201f26",
      buttonHover: "#909090",
      counterBackground: "#201f26",
      warning: "#ffbf00",
      remove: "#e63946",
      discount: "#0c88e0",
      mercadoPagoBackgroundColor: "#171E2E",
      qrCodeBackground: "#000000",
      goldmineGray: "#696969",
      goldmineRed: "#ab4e13",
      goldmineGreen: "#229828",
      goldmineBlue: "#2888b2",
      goldmineMint: "#2d51e0",
      highlightBorder: "#0776a4",
      highlightButton: "#0f0e17",
      highlightSpine: "#ece81f",
      breadcrumb: "#d3d3d3",
      pricingNotification: "rgb(168,166,8)",
      criticalNotification: "rgb(161,3,3)",
      messageNotification: "rgb(9,114,180)",
      progressRunning: "rgb(10,71,204)",
      progressError: "rgb(185,14,14)",
      progressSuccess: "rgb(9,131,28)",
      border: "#444444",
      ownChat: "#3b3a49",
      otherChat: "#201f26",
      chatSubheader: "#201f26",
      drawerBackgroundColor: "#201f26",
      divider: "#201f26",
      filterHeaderBackground: "#0d0c10"
    }
  },
  typography: {
    fontFamily: `"Inter", sans-serif`,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 1000
  }
});

export const blueTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#0f172a",
      paper: "#16213e"
    },
    primary: {
      main: "#e6f1ff",
      subtitle: "#9fb3d1"
    },
    secondary: {
      main: "#6c8db8"
    },
    action: {
      disabledBackground: "#334155",
      disabled: "#64748b"
    },
    colors: {
      main: "#0f172a",
      appBar: "#00002f",
      highlight: "#1e293b",
      disabled: "#64748b",
      gradeNumberBackground: "#1e293b",
      buttonBackground: "#16213e",
      buttonHover: "#243b55",
      counterBackground: "#1a2238",
      warning: "#fbbf24",
      remove: "#ef4444",
      discount: "#2689b2",
      mercadoPagoBackgroundColor: "#0e1a2f",
      qrCodeBackground: "#000814",
      goldmineGray: "#94a3b8",
      goldmineRed: "#d97706",
      goldmineGreen: "#22c55e",
      goldmineBlue: "#3b82f6",
      goldmineMint: "#6366f1",
      highlightBorder: "#38bdf8",
      highlightButton: "#1e293b",
      highlightSpine: "#fde047",
      breadcrumb: "#94a3b8",
      pricingNotification: "rgb(234,179,8)",
      criticalNotification: "rgb(185,28,28)",
      messageNotification: "rgb(56,189,248)",
      progressRunning: "rgb(10,71,204)",
      progressError: "rgb(185,14,14)",
      progressSuccess: "rgb(9,131,28)",
      border: "#22304a",
      ownChat: "#1e293b",
      otherChat: "#0f172a",
      chatSubheader: "#16213e",
      drawerBackgroundColor: "#0f172a",
      divider: "#0f172a",
      filterHeaderBackground: "#0b1220"
    }
  },
  typography: {
    fontFamily: `"Inter", sans-serif`,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 1000
  }
});

export const coffeeTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#1a120b",
      paper: "#24180f"
    },
    primary: {
      main: "#fff4e6",
      subtitle: "#e0bfa8"
    },
    secondary: {
      main: "#c89b7b"
    },
    action: {
      disabledBackground: "#3a2a1f",
      disabled: "#8c6b55"
    },
    colors: {
      main: "#1a120b",
      appBar: "#120c07",
      highlight: "#2b1d13",
      disabled: "#8c6b55",
      gradeNumberBackground: "#2b1d13",
      buttonBackground: "#24180f",
      buttonHover: "#3a2a1f",
      counterBackground: "#2a1c12",
      warning: "#ffb703",
      remove: "#e63946",
      discount: "#be6e11",
      mercadoPagoBackgroundColor: "#1c140d",
      qrCodeBackground: "#000000",
      goldmineGray: "#a1887f",
      goldmineRed: "#ef0808",
      goldmineGreen: "#419d4b",
      goldmineBlue: "#2ba6ea",
      goldmineMint: "#2d51e0",
      highlightBorder: "#fb8500",
      highlightButton: "#2b1d13",
      highlightSpine: "#ffd60a",
      breadcrumb: "#c89b7b",
      pricingNotification: "rgb(251,191,36)",
      criticalNotification: "rgb(180,35,24)",
      messageNotification: "rgb(251,133,0)",
      progressRunning: "rgb(10,71,204)",
      progressError: "rgb(185,14,14)",
      progressSuccess: "rgb(9,131,28)",
      border: "#3a2a1f",
      ownChat: "#2b1d13",
      otherChat: "#1a120b",
      chatSubheader: "#24180f",
      drawerBackgroundColor: "#1a120b",
      divider: "#1a120b",
      filterHeaderBackground: "#120c07"
    }
  },
  typography: {
    fontFamily: `"Inter", sans-serif`,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 1000
  }
});

interface CustomPaletteColorOptions {
  main: string;
  appBar?: string;
  highlight?: string;
  disabled?: string;
  subtitle?: string;
  gradeNumberBackground?: string;
  buttonBackground?: string;
  buttonHover?: string;
  counterBackground?: string;
  warning?: string;
  remove?: string;
  discount?: string;
  mercadoPagoBackgroundColor?: string;
  qrCodeBackground?: string;
  goldmineGray?: string;
  goldmineRed?: string;
  goldmineGreen?: string;
  goldmineBlue?: string;
  goldmineMint?: string;
  highlightBorder?: string;
  highlightButton?: string;
  highlightSpine?: string;
  breadcrumb?: string;
  pricingNotification?: string;
  criticalNotification?: string;
  messageNotification?: string;
  progressRunning?: string;
  progressError?: string;
  progressSuccess?: string;
  border?: string;
  ownChat?: string;
  otherChat?: string;
  chatSubheader?: string;
  drawerBackgroundColor?: string;
  divider?: string;
  filterHeaderBackground?: string;
}

declare module "@mui/material/styles" {
  interface Palette {
    colors: CustomPaletteColorOptions;
  }
  interface PaletteOptions {
    colors?: CustomPaletteColorOptions;
  }
  interface PaletteColor {
    subtitle?: string;
  }
  interface SimplePaletteColorOptions extends CustomPaletteColorOptions {}
}
